// extracted by mini-css-extract-plugin
export var addTopPadding = "subnav-list-module--addTopPadding--nHDng";
export var chronoNavigation = "subnav-list-module--chronoNavigation--ZPN8h";
export var fullWidth = "subnav-list-module--fullWidth--Q2SCn";
export var mainNav = "subnav-list-module--mainNav--jCAu0";
export var siblingNavigation = "subnav-list-module--siblingNavigation--E6nR0";
export var subNavList = "subnav-list-module--subNavList--Iwqbn";
export var subnavContainer = "subnav-list-module--subnavContainer--XoB9y";
export var verticalScroll = "subnav-list-module--verticalScroll--DJKOb";